import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Column = styled(({ padding, ...props }) => <BaseGrid item {...props} />)`
  padding: ${props => props.padding || '0 5px'};
`

export const DialogButtons = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 27px;
`

export const ExternalLink = styled('a')`
  align-content: baseline;
  color: ${props => props.theme.palette.blue[50]};
  display: flex;
  padding: ${props => props.padding};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const Row = styled(({ margin, ...props }) => <BaseGrid container {...props} />)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0 -5px'};
    padding: 12px 0 0;
    width: 100%;
  }
`

export const Strong = styled('span')`
  display: ${props => props.display};
  font-weight: bold;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding || '12px 9px 16px'} !important;

    &:first-child {
      padding: ${props => props.padding || '12px 9px 16px 0'} !important;
    }

    &:last-child {
      border-right: 0;
      padding: ${props => props.padding || '12px 0 16px 9px'} !important;
    }
  }
`
